import { sendAdminRequest } from '../../api/websocketApi';
import useStore from '../../store/store';

export interface AddMemberParams {
    userId: number;
    firstName: string;
    lastName: string;
    sex: 'male' | 'female';
    birthDate: Date;
    patientId?: string;
    referringPhysician?: string;
    ethnicity?: string;
}

interface APIResponse {
    success: boolean;
    errCode?:
        | 'invalid_param'
        | 'invalid_token'
        | 'auth_failed'
        | 'access_denied';
    errDetails?: string;
    memberId?: number;
    insertionDate?: Date;
}

const AddMember = (params: AddMemberParams) => {
    const setFormError = useStore.getState().setFormError;
    const setIsLoading = useStore.getState().setIsLoading;

    setIsLoading(true);
    sendAdminRequest(
        {
            endpoint: '/member/add',
            body: params,
        },
        (data: APIResponse) => {
            const { success, errCode, errDetails } = data;
            if (success) {
                setIsLoading(false);
            } else if (!success && errCode) {
                setIsLoading(false);
                setFormError('');
                setTimeout(() => setFormError(errCode), 0);
                console.error(errCode);
                if (errDetails) console.error(errDetails);
            }
        }
    );
};

export default AddMember;
